import React from "react";
import { Column, Columns, Title } from "@allxsmith/bestax-bulma";
import {formatCurrency} from "../../utils";

export default function RecurringPaymentPreview({
    intervalType,
    startDate,
    endDate,
    intervalDays,
    paymentAmount,
    maxRows
}) {
    const previewDates = [];
    const start = new Date(startDate);
    const end = new Date(endDate);
    let i = 0;

    // Iterate over dates until either max rows generated or end date is reached
    for(let date= new Date(startDate); (!endDate || (date <= end)) && i < maxRows; i++) {
        // push current date
        previewDates.push(date.toDateString());
        // add amount to date based on interval type
        switch(intervalType) {
            case 'WEEKLY':
                date.setDate(date.getDate() + 7);
                break;
            case 'MONTHLY':
                date.setMonth(date.getMonth() + 1);
                break;
            case 'YEARLY':
                date.setFullYear(date.getFullYear() + 1);
                break;
            case 'FIXED_DURATION':
                date.setDate(date.getDate() + (intervalDays * 1));
                break;
        }
    }

    return (
        <Columns isMultiline>
            <Column>
                <Title size="6">Dates Preview:</Title>
                {previewDates.map(dateString => <div>{paymentAmount && `${formatCurrency(paymentAmount)} on `} {dateString}</div>)}
                <br/>
            </Column>
        </Columns>
    );
}